/**
 * Reference URL field for impact/solution-style forms.
 */
import React from "react";
import InputTextArea from "ui/InputTextArea";

export interface LinkFieldProps {
  id: string;
  name: string;
  labelText: string;
  value: string;
  onChange: (value: string) => void;
  fieldPlaceholder?: string;
}

const LinkField: React.FC<LinkFieldProps> = ({
  id,
  name,
  labelText,
  value,
  onChange,
  fieldPlaceholder = "https://news.com/example-article",
}) => (
  <div className="form-control mb-2">
    <InputTextArea
      id={id}
      name={name}
      labelText={labelText}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fieldPlaceholder={fieldPlaceholder}
      autoComplete="url"
      spellCheck={false}
    />
  </div>
);

export default LinkField;
